import { Card, Row, Col, Spin, Upload, message, Button, Divider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect, useRef } from "react";
import ImgCrop from "antd-img-crop";
import { UploadOutlined, EditOutlined } from "@ant-design/icons";
import EditProfile from "./EditProfile";
import {
  GenerateMagicLink,
  UploadTeacherProfileImage,
  addAdminLog,
} from "../../redux/actions/TeacherAction";

const TeacherDetails = ({ teacher }) => {

  const dispatch = useDispatch();
  const [previewImage, setPreviewImage] = useState("");
  const [uploadingProfile, setUploadingProfile] = useState(false);
  const [magicLinkLoader, setMagicLinkLoader] = useState(false);
  const previewObjectUrlRef = useRef(null);
  const admin = useSelector(state => state.AdminReducer.admin)
  console.log("admin", admin)

  useEffect(() => {
    if(teacher){
    if(teacher.teacher.image){
      if(previewObjectUrlRef.current){
        URL.revokeObjectURL(previewObjectUrlRef.current);
        previewObjectUrlRef.current = null;
      }
      setPreviewImage(teacher.teacher.image)
    }else{
      if(previewObjectUrlRef.current){
        URL.revokeObjectURL(previewObjectUrlRef.current);
        previewObjectUrlRef.current = null;
      }
      setPreviewImage("")
    }
  }
  }, [teacher])

  useEffect(() => {
    return () => {
      if(previewObjectUrlRef.current){
        URL.revokeObjectURL(previewObjectUrlRef.current);
      }
    }
  }, [])
    
  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("Only image files are allowed.");
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error("Image must be smaller than 5MB.");
    }
    return isImage && isLt5M;
  };

  const setPreviewFromFile = (file) => {
    if (previewObjectUrlRef.current) {
      URL.revokeObjectURL(previewObjectUrlRef.current);
    }
    const blobUrl = URL.createObjectURL(file);
    previewObjectUrlRef.current = blobUrl;
    setPreviewImage(blobUrl);
  };

  const handleUploadRequest = ({ file, onSuccess, onError }) => {
    if (!file || !teacher?.teacher?._id) {
      onError?.("Missing file or teacher");
      return;
    }
    setUploadingProfile(true);
    const formData = new FormData();
    formData.append("teacherId", teacher.teacher._id);
    formData.append("image", file);

    const successHandler = (msg) => {
      setPreviewFromFile(file);
      message.success(msg);
      setUploadingProfile(false);
      onSuccess?.(msg);
    };

    const errorHandler = (msg) => {
      message.error(msg);
      setUploadingProfile(false);
      onError?.(msg);
    };

    dispatch(UploadTeacherProfileImage(formData, successHandler, errorHandler));
  };

  const magicLink = ()=>{
    setMagicLinkLoader(true)
    const onSuccess = (data) =>{
      console.log(data.token)
      setMagicLinkLoader(false)
      if(window.location.hostname == "admin.clapingo.com"){
        window.open(`https://teacher.clapingo.com?token=${data.token}`)
      }else{
        window.open(`https://teacher-web-git-staging-clapingo.vercel.app/?token=${data.token}`)
      }
      message.success('Magic link generated !')
      const payload = {
        role: admin?.details?.role,
        admin: admin?.details?.name,
        activity: "teacherMagicLogin",
        teacherId: teacher?.teacher?._id
      }
      var onLogSuccess = (res) => {
        console.log("res",res)
      }
      var onLogError = (msg) => {
        message.error(msg);
      }
      addAdminLog(payload, onLogSuccess, onLogError)
    }
    const onError = (errormsg) =>{
      setMagicLinkLoader(false)
      message.err(errormsg)
    }
    GenerateMagicLink(teacher.teacher._id,onSuccess,onError)
  }

  return (
    <Card className="teacher-details">
      {teacher ? (
        <>
          <Row>
            <Col span={6}>
           
              {/* <img
                src={
                  teacher.teacher.image
                    ? teacher.teacher.image
                    : "https://joeschmoe.io/api/v1/random"
                }
                alt="teacheravatar"
              /> */}

    <div className="teacher-profile-photo">
      <div
        className="teacher-profile-photo__preview"
        style={{
          width: "8rem",
          height: "8rem",
          borderRadius: "8px",
          overflow: "hidden",
          border: "1px solid #f0f0f0",
          marginBottom: "0.5rem",
        }}
      >
        <img
          src={
            previewImage
              ? previewImage
              : "https://joeschmoe.io/api/v1/random"
          }
          alt="teacheravatar"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </div>
      <ImgCrop rotate>
        <Upload
          accept="image/*"
          showUploadList={false}
          customRequest={handleUploadRequest}
          beforeUpload={beforeUpload}
        >
          <Button
            icon={
              previewImage ? <EditOutlined /> : <UploadOutlined />
            }
            loading={uploadingProfile}
          >
            {previewImage ? "Edit Photo" : "Upload Photo"}
          </Button>
        </Upload>
      </ImgCrop>
    </div>
    
            </Col>
            <Col span={18}>
              <Row>
                <Col span={12}>
                  <p className="teacher-name">
                      {teacher.teacher.name}{" "}
                      <span>+91 {teacher.teacher.phoneNumber}</span>
                    </p>
                    <p className="description">
                      {teacher.teacher.description?.replace(/\r?\n|\r/g, " ")}
                    </p>
                </Col>
                <Col span={6}>
                  <Button onClick={()=>magicLink()} loading={magicLinkLoader}>Magic link</Button>
                </Col>
              </Row>
 
              {/* <div className="access">
              <Tag color="#f50">Regular Demo</Tag>
              <Tag color="#f50">Regular Session</Tag>
              <Tag color="#f50">Kid's Demo</Tag>
              <Tag color="#f50">Kid's SEssion</Tag>
              </div> */}
             
              <Row>
                <Col span={4} className="active-stac">
                  <h5>Total class</h5>
                  <p>{teacher.totalSession}</p>
                </Col>
                <Col span={4} className="active-stac">
                  <h5>Rating</h5>
                  <p>{teacher?.teacher.rating}</p>
                </Col>
                <Col span={4} className="active-stac">
                  <h5>Referral Code</h5>
                  <p>{teacher?.teacher.referral}</p>
                </Col>
                <Col span={4} className="active-stac">
                  <h5>Earnings</h5>
                  <p>{teacher?.teacher.earnings}</p>
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider  plain/>
          
          <EditProfile teacher={teacher?.teacher} />
    
        </>
      ) : (
        <div className="spin-center">
          <Spin size="large" />
        </div>
      )}
    </Card>
  );
};

export default TeacherDetails;
